import { render, staticRenderFns } from "./ltr.vue?vue&type=template&id=d08af768"
import script from "./ltr.vue?vue&type=script&lang=js"
export * from "./ltr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports